import _ from 'underscore';
import Ladda from 'ladda';
import Moment from 'moment';
import UIHelper from '@/scripts/helpers/ui-helper';
import webcall from '@/scripts/webcall';

const DEFAULT_PER_PAGE = 10;
// FIXME: For now can only accommodate 1 component per page
let waypoint;

const _initWaypointLoadMore = function _initWaypointLoadMore($element) {
  if ($(window).width() > 544) {
    if (waypoint) {
      Waypoint.refreshAll();
    } else {
      waypoint = $element.find('.collection-question__load-more').waypoint({
        handler(direction) {
          if (!$('#comments__see-more').hasClass('hidden')) {
            _loadMore.call($element);
          }
        },
        offset: 'bottom-in-view',
      });
    }
  }
};

const _initEventHandlers = function _initEventHandlers($element) {
  $element.on('click', '.collection-question__load-more', (e) => {
    _loadMore.call($element);
  });

  _initWaypointLoadMore($element);
};

const _loadMore = function _loadMore() {
  const $element = this;
  const $btnLoadMore = $element.find('.collection-question__load-more');
  const laddaBtnLoadMore = Ladda.create($btnLoadMore.find('.btn__label')[0]);
  const pageNext = $btnLoadMore.data('page-next');
  const selectedTopicId = $btnLoadMore.data('selected_topic_id');
  const tplCardQuestion = _.template($element.find('.tpl-card-question').html());
  const replyHTMLArray = [];

  if ($element.hasClass('--loading-more')) {
    return;
  }
  $element.addClass('--loading-more');
  laddaBtnLoadMore.start();
  // SOU: Inflexible APIs made me did this
  if (selectedTopicId) {
    if (selectedTopicId === 'featured') { // BY FEATURED
      webcall.community.getFeaturedQuestions({
        current_page: pageNext,
        per_page: DEFAULT_PER_PAGE,
      }, (response) => {
        for (const index in response.questions) {
          response.questions[index].created_at = Moment(response.questions[index].created_at).fromNow();
          if (response.questions[index].latest_comment) {
            response.questions[index].latest_comment.created_at = Moment(response.questions[index].latest_comment.created_at).fromNow();
          }
          replyHTMLArray.push(tplCardQuestion({
            question: response.questions[index],
          }));
        }
        $element.find('.collection-question__cards').append(replyHTMLArray.reduce((prev, curr, idx, arr) => prev + curr, ''));

        $element.find('.avatar').each((index, avatarElement) => {
          const $this = $(avatarElement);
          if ($this.attr('src') === '' && typeof $this.data('name') !== 'undefined') {
            $this.initial();
          }
        });

        $element.removeClass('--loading-more');
        laddaBtnLoadMore.stop();
        _initWaypointLoadMore($element);

        if (response.current_page < response.total_pages - 1) {
          $btnLoadMore
            .data('page-next', response.current_page + 1)
            .removeClass('hidden');
        } else {
          $btnLoadMore
            .addClass('hidden');
        }

        const loc = window.location.hash.substr(1);
        if (loc) {
          UIHelper.scrollTo(loc);
        }
      });
    } else { // BY TOPIC
      webcall.community.getQuestionsByTopic({
        topic: $btnLoadMore.data('selected_topic_id'),
        current_page: pageNext,
        per_page: DEFAULT_PER_PAGE,
      }, (response) => {
        for (const index in response.questions) {
          response.questions[index].body = response.questions[index].body ? UIHelper.simpleFormat(response.questions[index].body) : '';
          response.questions[index].created_at = Moment(response.questions[index].created_at).fromNow();
          if (response.questions[index].latest_comment) {
            response.questions[index].latest_comment.created_at = Moment(response.questions[index].latest_comment.created_at).fromNow();
          }
          replyHTMLArray.push(tplCardQuestion({
            question: response.questions[index],
          }));
        }

        $element.find('.collection-question__cards').append(replyHTMLArray.reduce((prev, curr, idx, arr) => prev + curr, ''));

        $element.find('.avatar').each((index, element) => {
          const $this = $(element);
          if ($this.attr('src') === '' && typeof $this.data('name') !== 'undefined') {
            $this.initial();
          }
        });

        $element.removeClass('--loading-more');
        laddaBtnLoadMore.stop();
        _initWaypointLoadMore($element);

        if (response.current_page < response.total_pages - 1) {
          $btnLoadMore
            .data('page-next', response.current_page + 1)
            .removeClass('hidden');
        } else {
          $btnLoadMore
            .addClass('hidden');
        }

        const loc = window.location.hash.substr(1);
        if (loc) {
          UIHelper.scrollTo(loc);
        }
      });
    }
  } else { // BY NEW
    webcall.community.getQuestions({
      current_page: pageNext,
      per_page: DEFAULT_PER_PAGE,
    }, (response) => {
      for (const index in response.questions) {
        response.questions[index].created_at = Moment(response.questions[index].created_at).fromNow();
        if (response.questions[index].latest_comment) {
          response.questions[index].latest_comment.created_at = Moment(response.questions[index].latest_comment.created_at).fromNow();
        }
        replyHTMLArray.push(tplCardQuestion({
          question: response.questions[index],
        }));
      }
      $element.find('.collection-question__cards').append(replyHTMLArray.reduce((prev, curr, idx, arr) => prev + curr, ''));

      $element.find('.avatar').each((index, avatarElement) => {
        const $this = $(avatarElement);
        if ($this.attr('src') === '' && typeof $this.data('name') !== 'undefined') {
          $this.initial();
        }
      });

      $element.removeClass('--loading-more');
      laddaBtnLoadMore.stop();
      _initWaypointLoadMore($element);

      if (response.current_page < response.total_pages - 1) {
        $btnLoadMore
          .data('page-next', response.current_page + 1)
          .removeClass('hidden');
      } else {
        $btnLoadMore
          .addClass('hidden');
      }

      const loc = window.location.hash.substr(1);
      if (loc) {
        UIHelper.scrollTo(loc);
      }
    });
  }
};

const VSCollectionQuestion = {
  init() {
    $('.collection-question').each((collectionQuestionIndex, collectionQuestion) => {
      const $el = $(collectionQuestion);

      _initEventHandlers($el);
    });
  },
};

export default VSCollectionQuestion;
